import { render, staticRenderFns } from "./JobGradeAdd.vue?vue&type=template&id=287976f0&"
import script from "./JobGradeAdd.vue?vue&type=script&lang=js&"
export * from "./JobGradeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports